import './index.scss'
import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static get targets() {
    return ['input']
  }

  connect() {
    console.log('controller input number connected')
  }

  blockInvalidCharacters(event) {
    console.log('action triggered')
    // Allow keyboard shortcuts
    if (
      event.getModifierState('Meta') ||
      event.getModifierState('Control') ||
      event.getModifierState('Alt')
    ) {
      return
    }
    const key = event.key

    // Allow non-printable keys
    if (key.length !== 1 || key === '\x00') {
      return
    }

    // Prevent any non-numeric keys, but allow . for decimals
    // and - for negative values
    if ((key < '0' || key > '9') && key !== '.' && key !== '-') {
      event.preventDefault()
    }
  }
}
